/** 首页热门分类：2 行 × 7 列，图标来自 homepage/首页热门分类图标(1) */
export const HOT_CATEGORIES = [
  { id: 3, name: '日化用品', icon: require('@category-icons/3.jpg') },
  { id: 5, name: '医药用品', icon: require('@category-icons/5.jpg') },
  { id: 9, name: '科学仪器', icon: require('@category-icons/9.jpg') },
  { id: 10, name: '医疗器械', icon: require('@category-icons/10.jpg') },
  { id: 14, name: '珠宝钟表', icon: require('@category-icons/14.jpg') },
  { id: 20, name: '家具用品', icon: require('@category-icons/20.jpg') },
  { id: 25, name: '服装鞋帽', icon: require('@category-icons/25.jpg') },
  { id: 28, name: '健身器材', icon: require('@category-icons/28.jpg') },
  { id: 29, name: '食品', icon: require('@category-icons/29.jpg') },
  { id: 30, name: '方便食品', icon: require('@category-icons/30.jpg') },
  { id: 32, name: '啤酒饮料', icon: require('@category-icons/32.jpg') },
  { id: 33, name: '酒精饮品', icon: require('@category-icons/33.jpg') },
  { id: 35, name: '广告销售', icon: require('@category-icons/35.jpg') },
  { id: 43, name: '餐饮住宿', icon: require('@category-icons/43.jpg') }
]

export const CATEGORY_GRID_COLUMNS = 7
